import axios from "axios";
import React, { useState, useEffect } from "react";

const UserClients = ({ userDetails }) => {
  const [clients, setClients] = useState([]);
  const [sales, setSales] = useState([]);
  const [previous, setPrevious] = useState([]);
  var [root, setRoot] = useState({
    id: "Swalok@9",
    name: "Swalok Group",
    sales: 0.0,
    left: null,
    right: null,
  });

  const dummyChild = {
    id: "No User Added",
    name: "No User",
    sales: 0.0,
    left: null,
    right: null,
  };

  var [totalSales, setTotalSales] = useState({ leftSales: [], rightSales: [] });

  const sumValues = (arr) => {
    return arr.reduce((total, obj) => {
      return total + parseFloat(obj.received);
    }, 0);
  };

  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("sale_history");
    localStorage.removeItem("all_clients");
  });

  function getNodes(parent) {
    root = {};
    totalSales = { leftSales: [], rightSales: [] };
    setTotalSales(totalSales);
    if (parent === "No User Added") {
      root = {
        id: "No User Added",
        name: "No User",
        sales: 0.0,
        matching_sales: 0.0,
        left: dummyChild,
        right: dummyChild,
      };
      setRoot(root);
      return;
    }
    const parentRoot = clients.find(
      (element) => element["client_id"] === parent
    );
    const rootSalesData = sales.filter((s) => s["agent_name"] === parent);
    var rootSales = 0;

    if (rootSalesData) {
      rootSales = sumValues(rootSalesData);
    }
    root = {
      id: parentRoot["client_id"],
      name: parentRoot["name"],
      sales: rootSales,
      left: parentRoot["left_child"],
      right: parentRoot["right_child"],
    };

    const leftChild = clients.find(
      (element) => element["client_id"] === root["left"]
    );
    const rightChild = clients.find(
      (element) => element["client_id"] === root["right"]
    );

    if (!leftChild) {
      root = { ...root, left: dummyChild };
    } else {
      const leftSalesData = sales.filter(
        (s) => s["agent_name"] === leftChild["client_id"]
      );
      var leftSales = 0;

      if (leftSalesData) {
        leftSales = sumValues(leftSalesData);
        totalSales = {
          ...totalSales,
          leftSales: [...totalSales.leftSales, leftSales],
        };
        setTotalSales(totalSales);
      }
      root = {
        ...root,
        left: {
          id: leftChild["client_id"],
          name: leftChild["name"],
          sales: leftSales,
          left: leftChild["left_child"],
          right: leftChild["right_child"],
        },
      };
      getChildsLeft(root.left.left);
      getChildsLeft(root.left.right);
    }

    if (!rightChild) {
      root = { ...root, right: dummyChild };
    } else {
      const rightSalesData = sales.filter(
        (s) => s["agent_name"] === rightChild["client_id"]
      );
      var rightSales = 0;

      if (rightSalesData) {
        rightSales = sumValues(rightSalesData);
        totalSales = {
          ...totalSales,
          rightSales: [...totalSales.rightSales, rightSales],
        };
        setTotalSales(totalSales);
      }
      root = {
        ...root,
        right: {
          id: rightChild["client_id"],
          name: rightChild["name"],
          sales: rightSales,
          left: rightChild["left_child"],
          right: rightChild["right_child"],
        },
      };
      getChildsRight(root.right.left);
      getChildsRight(root.right.right);
    }
    setRoot(root);
  }

  // Fetch Sales
  const fetchSales = async () => {
    try {
      const response = await axios.get(
        "https://api.swalokgroup.com/api/get-sale-invoice"
      );
      setSales(response.data);
      localStorage.setItem("sale_history", JSON.stringify(response.data));
    } catch (error) {
      console.log(error);
    }
  };

  // Fetch clients
  const fetchClients = async () => {
    try {
      const response = await axios.get(
        "https://api.swalokgroup.com/api/get-all-clients"
      );
      setClients(response.data);
      localStorage.setItem("all_clients", JSON.stringify(response.data));
    } catch (error) {
      console.log(error);
    }
  };

  function getChildsLeft(parent) {
    if (!parent) {
      return;
    }

    const rootChildrens = clients.find(
      (element) => element["client_id"] === parent
    );
    const salesData = sales.filter(
      (s) => s["agent_name"] === rootChildrens["client_id"]
    );
    var salesTotal = 0;

    if (salesData) {
      salesTotal = sumValues(salesData);
      totalSales = {
        ...totalSales,
        leftSales: [...totalSales.leftSales, salesTotal],
      };
      setTotalSales(totalSales);
    }
    if (rootChildrens["left_child"]) {
      getChildsLeft(rootChildrens["left_child"]);
    }
    if (rootChildrens["right_child"]) {
      getChildsLeft(rootChildrens["right_child"]);
    }
  }

  function getChildsRight(parent) {
    if (!parent) {
      return;
    }

    const rootChildrens = clients.find(
      (element) => element["client_id"] === parent
    );
    const salesData = sales.filter(
      (s) => s["agent_name"] === rootChildrens["client_id"]
    );
    var salesTotal = 0;

    if (salesData) {
      salesTotal = sumValues(salesData);
      totalSales = {
        ...totalSales,
        rightSales: [...totalSales.rightSales, salesTotal],
      };
      setTotalSales(totalSales);
    }
    if (rootChildrens["left_child"]) {
      getChildsRight(rootChildrens["left_child"]);
    }
    if (rootChildrens["right_child"]) {
      getChildsRight(rootChildrens["right_child"]);
    }
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        // Fetch all data in parallel
        await Promise.all([fetchClients(), fetchSales()]);
      } catch (error) {
        console.log(error);
      }
    };

    // Check if data exists in localStorage to prevent re-fetching
    const storedClients = localStorage.getItem("all_clients");
    const storedSales = localStorage.getItem("sale_history");
    if (!storedSales || !storedClients) {
      loadData();
    } else {
      setClients(JSON.parse(storedClients));
      setSales(JSON.parse(storedSales));
    }
  }, [setClients, setSales]);

  return (
    <section className="py-5">
      <div className="container">
        <div className="sec-subheading">
          <hr />
          <span>All Team Members</span>
          <hr />
        </div>

        <div className="clients-tree mt-4">
          <div className="d-flex justify-content-between">
            <p
              onClick={() => {
                if (previous.length > 0) {
                  getNodes(previous.pop());
                }
              }}
            >
              <i className="fa-solid fa-circle-left fs-2 cursor-pointer"></i>
            </p>
            {previous.length < 1 && clients.length > 0 && (
              <button
                className="admin-btn px-3"
                onClick={() => {
                  getNodes(userDetails.client_id);
                }}
              >
                Fetch Team
              </button>
            )}
          </div>

          <div className="d-flex justify-content-around text-center fw-bold">
            <p>
              Left Sales:{" "}
              {totalSales.leftSales.reduce((acc, value) => acc + value, 0)}
            </p>
            <p>
              Right Sales:{" "}
              {totalSales.rightSales.reduce((acc, value) => acc + value, 0)}
            </p>
          </div>

          <div className="root-client">
            <div className="client-node">
              <p className="text-capitalize">
                {root.name}
                <br />
                {root.id}
              </p>
              <p>Total Sale: ₹ {root.sales}</p>
            </div>
            <div className="d-flex">
              {root.left && (
                <div className="sub-clients">
                  <div className="member-node-outer text-center">
                    <div
                      className="client-node"
                      onClick={() => {
                        if (root.id !== "No User Added") {
                          setPrevious([...previous, root.id]);
                        }
                        getNodes(root.left.id);
                      }}
                    >
                      <p className="text-capitalize">
                        {root.left.name}
                        <br />
                        {root.left.id}
                      </p>
                      <p>Total Sale: ₹ {root.left.sales}</p>
                    </div>
                  </div>
                </div>
              )}
              <div style={{ width: "150px" }}></div>
              {root.right && (
                <div className="sub-clients">
                  <div className="member-node-outer text-center">
                    <div
                      className="client-node"
                      onClick={() => {
                        if (root.id !== "No User Added") {
                          setPrevious([...previous, root.id]);
                        }
                        getNodes(root.right.id);
                      }}
                    >
                      <p className="text-capitalize">
                        {root.right.name}
                        <br />
                        {root.right.id}
                      </p>
                      <p>Total Sale: ₹ {root.right.sales}</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserClients;
